import { render, staticRenderFns } from "./ProjectCardSkeletonLoader.vue?vue&type=template&id=0294487c&scoped=true"
import script from "./ProjectCardSkeletonLoader.vue?vue&type=script&lang=js"
export * from "./ProjectCardSkeletonLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0294487c",
  null
  
)

export default component.exports